import { environment as baseEnv } from './environment.dev'

export const environment = {
  ...baseEnv,
  apiUrl: 'https://dev-alt-12-api.eshyft.com/api/v2',
  socketUrl: 'https://dev-alt-12-api.eshyft.com',
  firebaseTenantId: 'dev-alt-12-xc31k',
  verifyOtpUrl: 'https://verify-otp-lgtjqnr75q-uk.a.run.app'
}
